<template>
  <b-modal ref="modal-trocar-empresa" size="sm" @hide="close()" hide-footer modal-class="modal">
    <template v-slot:modal-title>
      <span class="font-weight-bold">{{ $t('Trocar Empresa') }}</span>
    </template>

    <div class="p-0">
      <div v-if="isLoading">
        <div class="text-center m-3">
          <b-spinner variant="primary" label="Text Centered"></b-spinner>
        </div>
      </div>
      <div v-if="erro">
        <div class="text-center alert alert-danger">
          {{ erro }}
        </div>
      </div>

      <div class="d-flex justify-content-between p-2 mb-3 selected-empresa" v-if="!isLoading && !erro">
        <div class="d-flex">
          <avatar
            :initials="getInitials(empresaLogada.nome_empresa)"
            :size="50"
            :fontSize="22"
            :backgroundColor="empresaLogada.cor_empresa"
          />
          <div class="ml-2">
            <span class="font-weight-bold d-block">{{ empresaLogada.nome_empresa }}</span>
            <span class="badge badge-primary badge-pill">#{{ empresaLogada.id_empresa }}</span>
          </div>
        </div>
        <div class="d-flex align-items-center">
          <span class="ion ion-md-checkmark text-primary font-weight-bold h3 m-0 mr-2"></span>
        </div>
      </div>

      <b-button-group class="w-100 mb-3" size="md" v-if="!isLoading && !erro">
        <b-button
          class="w-100"
          style="border-radius: 12px 0 0 12px"
          :variant="painel == 1 ? 'primary' : 'dark'"
          @click="painel = 1"
        >
          <font-awesome-icon class="m-0 h5" :icon="['fas', 'globe-americas']" />
          <span class="font-weight-bold">{{ $t('Produção') }}</span>
        </b-button>

        <b-button
          class="w-100"
          style="border-radius: 0 12px 12px 0"
          :variant="painel == 2 ? 'primary' : 'dark'"
          @click="painel = 2"
        >
          <font-awesome-icon class="m-0 h5" :icon="['fas', 'flask']" />
          <span class="font-weight-bold">{{ $t('Teste') }}</span>
        </b-button>
      </b-button-group>

      <b-form-row class="mb-3" v-if="!isLoading && !erro">
        <input
          type="search"
          class="form-control mx-1"
          v-model="filtro"
          :placeholder="$t('Digite para pesquisar')"
          @input="filtrarEmpresas(filtro)"
        />
      </b-form-row>

      <div v-if="!isLoading" style="overflow-y: auto; max-height: calc(100vh - 370px)">
        <div v-for="empresa in empresasProdOrTeste(painel)" :key="empresa.id_empresa">
          <div style="border-top: 1px solid #e0e0e0" class="mx-3 pb-1"></div>
          <div
            class="d-flex justify-content-between p-2 container-empresa cursor-pointer mb-1"
            @click="trocarEmpresa(empresa)"
          >
            <div class="d-flex">
              <avatar
                :initials="getInitials(empresa.nome_empresa)"
                :size="50"
                :fontSize="22"
                :backgroundColor="
                  empresa.configuracao_empresa.iconColorGestor
                    ? empresa.configuracao_empresa.iconColorGestor
                    : '#3398DB'
                "
              />
              <div class="ml-2">
                <span class="font-weight-bold d-block">{{ empresa.nome_empresa }}</span>
                <span class="badge badge-secondary badge-pill">#{{ empresa.id_empresa }}</span>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <div class="bg-white icon-btn btn-xs btn-circle">
                <font-awesome-icon :icon="['fas', 'angle-right']" class="h5 text-black" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: ['openModal'],
  data() {
    return {
      isLoading: false,
      empresas: [],
      empresaLogada: {
        id_empresa: '',
        nome_empresa: ' ',
        cor_empresa: '#3398DB'
      },
      erro: null,
      painel: 1,
      filtro: null,
      empresasFiltradas: [],
      modelList: [
        {
          key: 'select',
          label: '',
          class: 'text-nowrap text-center',
          sortable: false
        },
        {
          key: 'nome_filtro',
          label: this.$i18n.t('Empresa'),
          sortable: true,
          class: 'text-left'
        }
      ]
    };
  },

  methods: {
    getInitials(name) {
      const names = name.trim().split(' ');
      let initials = '';

      for (let i = 0; i < names.length; i++) {
        const initialsArray = names[i].split(/[-()]/);
        for (let j = 0; j < initialsArray.length; j++) {
          const initial = this.getValidInitial(initialsArray[j].charAt(0));
          initials += initial.toUpperCase();
        }
      }

      return initials;
    },
    getValidInitial(name) {
      let initial = '';
      for (let i = 0; i < name.length; i++) {
        if (name.charAt(i) !== ' ') {
          initial = name.charAt(i);
          break;
        }
      }
      return initial;
    },
    filtrarEmpresas(value) {
      this.empresasFiltradas = this.empresas.filter(function (el) {
        return el.nome_filtro.toLowerCase().includes(value.toLowerCase());
      });
    },
    getEmpresas() {
      this.isLoading = true;
      this.$atenaList
        .getEmpresas({
          columns:
            'id as id_empresa,nome as nome_empresa,teste as empresa_teste,configuracao as configuracao_empresa,cotacao_maxima as cotacao_maxima_empresa,venda_pin,venda_api,venda_bolao,venda_eticket,venda_slot,venda_me,exibir_financeiro,exibir_resultados,limite_maximo_venda,cotacao_favorito,comissao_retida,exibir_coluna_impresso,registrar_cliente,centro_de_custo,inverter_sinais_financeiro,venda_atm,id_template_odd,menu_avancado, deduzir_cancelamentos',
          order: 'empresa_teste, nome_empresa'
        })
        .then((res) => {
          this.empresas = res.data;
          let idxLogada = null;
          this.empresas.forEach((item, index) => {
            item.nome_filtro = `${item.id_empresa.toString().padStart(3, '0')} - ${item.nome_empresa}`;
            item.configuracao_empresa = item.configuracao_empresa ? JSON.parse(item.configuracao_empresa) : {};

            if (item.id_empresa == this.$store.state.user.info.id_empresa) {
              idxLogada = index;
              this.empresaLogada.id_empresa = item.id_empresa;
              this.empresaLogada.nome_empresa = item.nome_empresa;
              this.empresaLogada.cor_empresa = item.configuracao_empresa.iconColorGestor
                ? item.configuracao_empresa.iconColorGestor
                : '#3398DB';
            }
          });
          this.empresas.splice(idxLogada, 1);
          this.empresasFiltradas = res.data;
          this.isLoading = false;
          this.erro = null;
        })
        .catch((err) => {
          this.isLoading = false;
          this.erro =
            err != null && err.message !== undefined
              ? err.message
              : this.$i18n.t('Entre em contato com o Administrador do Sistema.');
          this.$notify({
            group: 'notifications-default',
            type: 'error',
            title:
              err != null && err.message !== undefined
                ? this.$i18n.t('Erro')
                : this.$i18n.t('Erro ao Carregar Dados'),
            text:
              err != null && err.message !== undefined
                ? err.message
                : this.$i18n.t('Entre em contato com o Administrador do Sistema.')
          });
        });
    },
    empresasProdOrTeste(painel) {
      if (painel == 1) {
        return this.empresasFiltradas.filter(function (el) {
          return el.empresa_teste == false;
        });
      } else {
        return this.empresasFiltradas.filter(function (el) {
          return el.empresa_teste == true;
        });
      }
    },
    close() {
      this.$emit('closeModal', {});
      this.empresas = [];
      this.erro = null;
      this.$refs['modal-trocar-empresa'].hide();
    },
    trocarEmpresa(item) {
      this.isLoading = true;
      this.$atenaList
        .alterarEmpresa({
          empresa: item.id_empresa
        })
        .then((res) => {
          this.isLoading = false;
          this.$store.dispatch('user/registerTrocarEmpresa', item);
          localStorage.setItem('appTimezone', res.appTimezone);
          localStorage.setItem('userTimezone', res.userTimezone);

          this.updatePermissaoEmpresa(res?.permissoes);

          this.$emit('closeModal', {});
          this.empresas = [];
          this.erro = null;
          this.$refs['modal-trocar-empresa'].hide();
          this.$notify({
            group: 'notifications-default',
            type: 'success',
            title: this.$i18n.t('Sucesso'),
            text: this.$i18n.t('Empresa Alterada com Sucesso'),
            duration: 4000
          });
          !this.$util.checkCurrentRoute({ path: '/Dashboard' }) && this.$router.push('/Dashboard');
        })
        .catch((err) => {
          this.isLoading = false;
          this.$notify({
            group: 'notifications-default',
            type: 'warn',
            title: this.$i18n.t('Erro ao Alterar Empresa'),
            text: `${err.code} - ${err.message}`,
            duration: 4000
          });
        });
    },
    updatePermissaoEmpresa(permissoes) {
      let info = localStorage.getItem('info') ? JSON.parse(localStorage.getItem('info')) : {};
      let permissoesMfa = permissoes ? JSON.stringify(permissoes) : '{}';

      info = {
        ...info,
        empresa__permissoes: permissoesMfa
      };

      localStorage.setItem('info', JSON.stringify(info));
    }
  },

  watch: {
    openModal(v) {
      if (v == true) {
        this.getEmpresas();
        this.$refs['modal-trocar-empresa'].show();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .modal > .modal-dialog > .modal-content {
  background: #f5f5f5;
}

.selected-empresa {
  background: #cceefe;
  border-radius: 12px;
}
.container-empresa {
  border-radius: 12px;
}
.container-empresa:hover {
  background: #e0e0e0;
  .btn-xs {
    display: block;
  }
}
.btn-circle.btn-xs {
  display: none;
  width: 30px;
  height: 30px;
  padding: 6px 0px;
  border-radius: 15px;
  font-size: 8px;
  text-align: center;
}
.form-control {
  border-radius: 12px;
}
</style>
